import React from 'react';
import PropTypes from 'prop-types';
import { Link, useParams } from 'react-router-dom';
import { Tab, Tabs, Box } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import PATHS from 'constants/paths';

const LinkTab = (props) => {
  return <Tab component={Link} color="primary" {...props} />;
};

const ConversationTabs = ({ tab, rightMenu }) => {
  const { conversationId } = useParams();

  return (
    <Box boxShadow={3} display="flex" justifyContent="space-between">
      <div />
      <Tabs value={tab} indicatorColor="primary" textColor="primary" centered>
        <LinkTab
          label={<FormattedMessage id="Bookings" defaultMessage="Bookings" />}
          disabled={tab === 0}
          to={PATHS.conversations.bookings.replace(':conversationId', conversationId)}
        />
        <LinkTab
          label={<FormattedMessage id="Messages" defaultMessage="Messages" />}
          disabled={tab === 1}
          to={PATHS.conversations.read.replace(':conversationId', conversationId)}
        />
      </Tabs>
      {!rightMenu ? <div /> : rightMenu}
    </Box>
  );
};

ConversationTabs.propTypes = {
  tab: PropTypes.number.isRequired,
  rightMenu: PropTypes.node,
};

export default ConversationTabs;
